import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
export function AfterSchoolWhatYouLearn() {
  return <section className="py-24 bg-off-white" data-id="element-677">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-678">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-679">
          <div data-id="element-680">
            <h2 className="text-4xl md:text-5xl text-ink mb-8" data-id="element-681">
              What You'll Learn
            </h2>
            <ul className="flex flex-col gap-4" data-id="element-682">
              {['Respect for teachers, parents, and peers', 'How to follow multi-step instructions', 'Physical coordination and balance', 'Basic self-defense fundamentals', 'How to handle challenges with resilience'].map((item, idx) => <li key={idx} className="flex items-start gap-4 text-lg text-gray-warm" data-id="element-683">
                  <CheckCircle2 className="w-6 h-6 text-storm-red shrink-0 mt-0.5" data-id="element-684" />
                  <span data-id="element-685">{item}</span>
                </li>)}
            </ul>
            <div className="mt-10" data-id="element-686">
              <Link to="/SignMeUp" className="btn-primary" data-id="element-687">
                Claim Your Child's Free Week
              </Link>
            </div>
          </div>
          <div className="relative rounded-2xl overflow-hidden shadow-xl h-[400px]" data-id="element-688">
            <img src="https://images.unsplash.com/photo-1517438476312-10d79c077509?auto=format&fit=crop&w=1200&q=80" alt="Training at Storm Taekwondo" className="block w-full h-full object-cover" data-id="element-689" />
          </div>
        </div>
      </div>
    </section>;
}